/**
 * 优惠券包列表
 */
import { PACKAGELIST } from '../types';

export default {
    name: `${PACKAGELIST}`,
    path: '/packageList',
    component: () => import(/* webpackChunkName: 'couponPackage' */ '@/views/couponPackage/'),
    redirect: { name: `${PACKAGELIST}Index` },
    meta: {
        title: '券包列表',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${PACKAGELIST}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'couponPackage' */ '@/views/couponPackage/home/Home.vue'),
        },
        // 优惠券包详情
        {
            name: `${PACKAGELIST}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'couponPackageDetail' */ '@/views/couponPackage/detail/Detail.vue'),
        },
        // 优惠券包创建
        {
            name: `${PACKAGELIST}Create`,
            path: 'create',
            component: () => import(/* webpackChunkName: 'couponPackageCreate' */ '@/views/couponPackage/create/Create.vue'),
        },
        // 发券包
        {
            name: `${PACKAGELIST}Send`,
            path: 'send/:id',
            component: () => import(/* webpackChunkName: 'couponPackageSend' */ '@/views/couponPackage/send/Send.vue'),
        },
    ],
};
